<template>
  <!-- 运费说明 -->
  <div class="con">
    <van-action-sheet v-model="show" title="运费说明" @close="close">
      <div class="content border_top1px">
        <div class="font12 font_weight400 colo087 text_left line_height_17">
          <!-- 满88元包邮，不足金额的订单收取10元运费，以商品活动后的总金额为准，不含运费，使用虚拟资产（优惠券）不影响包邮的计算，特殊商品单独计算运费。 -->
          {{ mallretailspu.freight ? mallretailspu.freight.detail : "" }}
        </div>
        <div
          class="font14 font_weight500 colof line_height_40 btn"
          @click="close"
        >
          确认
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  .content {
    margin: 2px 12px 0;
    padding: 16px 8px;
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 135px;
    }
  }
}
</style>
